import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mb-3 bg-white shadow border rounded-md mx-4 lg:mx-1 pb-3" }
const _hoisted_2 = { class: "flex text-sm font-bold text-base lg:grid" }
const _hoisted_3 = { class: "flex lg:justify-center" }
const _hoisted_4 = { class: "flex text-gray-500" }
const _hoisted_5 = { class: "px-1" }
const _hoisted_6 = { class: "" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("button", { class: "text-base px-2 mx-1 rounded lg:hidden" }, " + ")
], -1)
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "grid grid-cols-4 gap-2 mx-2 mt-2 bg-white lg:gap-1 lg:grid-cols-3" }

import { ref, onMounted, onUnmounted } from 'vue';
import EventButton from "@/components/Reservation/EventButton.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'DateHourGrid',
  props: {
  date: String,
  dayName: String,
  dayMonth: String,
  day: String,
  events: Object,
},
  setup(__props) {

const props = __props;

let isVisible = ref(true);
let isLargeScreen = ref(window.innerWidth >= 768);



const toggleVisibility = () => {
  if (isLargeScreen.value) {
    isVisible.value = true;
  } else {
    isVisible.value = !isVisible.value;
  }
};

onMounted(() => {
  // Update isLargeScreen when the window is resized
  const handleResize = () => {
    isLargeScreen.value = window.innerWidth >= 768;
  };

  window.addEventListener('resize', handleResize);

  onUnmounted(() => {
    window.removeEventListener('resize', handleResize);
  });
});

// Initialize isVisible based on the screen size
onMounted(toggleVisibility);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "flex justify-between p-2 bg-white lg:justify-center lg:shadow-none lg:border-none",
      onClick: toggleVisibility
    }, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _createElementVNode("p", _hoisted_3, _toDisplayString(props.dayName), 1)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("p", _hoisted_5, _toDisplayString(props.day), 1),
            _createElementVNode("p", _hoisted_6, _toDisplayString(props.dayMonth), 1)
          ])
        ])
      ]),
      _hoisted_7
    ]),
    (_unref(isVisible))
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.events, (it) => {
              return (_openBlock(), _createElementBlock("div", {
                key: it.scheduledHourCode
              }, [
                (!it.isScheduled)
                  ? (_openBlock(), _createBlock(EventButton, {
                      key: 0,
                      isScheduled: it.isScheduled,
                      scheduledHourCode: it.scheduledHourCode,
                      date: props.date,
                      dayName: props.dayName,
                      dayMonth: props.dayMonth,
                      day: props.day
                    }, null, 8, ["isScheduled", "scheduledHourCode", "date", "dayName", "dayMonth", "day"]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})